import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { dashFeatureById, userProfile } from 'redux/saga/entities/bound';
import { takeEvery, all, call, put, select } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { replace as replacePath } from 'react-router-redux';
import { NPS_SURVEY_SOURCE } from 'features/Settings/Membership/NpsSurvey/NpsSurvey.constants';
import { SUPPORT_CHAT_FEATURE_ID, CANCEL_CHAT_FEATURE_ID } from 'constants/chat';
import { whenZDChatIsLoaded } from 'helpers/chat';

export const LOAD_USER_PROFILE = 'classpass/Chat/LOAD_USER_PROFILE';
export const SHOW_NPS_SURVEY = 'classpass/Chat/SHOW_NPS_SURVEY';
export const loadUserProfile = () => ({ type: LOAD_USER_PROFILE });
export const showNpsSurvey = () => ({ type: SHOW_NPS_SURVEY });

export function* doLoadZendeskFlags(client) {
  yield all([
    call(fetchEntityIfNeeded, dashFeatureById, [client, SUPPORT_CHAT_FEATURE_ID]),
    call(fetchEntityIfNeeded, dashFeatureById, [client, CANCEL_CHAT_FEATURE_ID]),
  ]);
}

export function* doLoadUserProfile(client) {
  if (yield select(isLoggedIn)) {
    const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
    yield call(whenZDChatIsLoaded, () =>
      window.zE?.('webWidget', 'identify', {
        name: `${profile.first_name} ${profile.last_name}`,
        email: profile.email,
      })
    );
  }
}

export function* doShowNpsSurvey() {
  yield put(replacePath(`/settings/nps-survey?source=${NPS_SURVEY_SOURCE.cancelChat}`));
}

export function* watchChat(client) {
  yield takeEvery(LOAD_USER_PROFILE, doLoadUserProfile, client);
  yield takeEvery(SHOW_NPS_SURVEY, doShowNpsSurvey, client);
}
